import { useEffect } from "react";
import {
  PREVIEW_MODAL_KEY,
  useSessionStorage,
} from "react/components/NewVersionOptIn/OptInLandingPage/hooks/useSessionStorage";
import { useCircleV4 } from "react/hooks/useCircleV4";

import { useAdminPreviewModal } from "..";

export const useRenderAdminPreviewModal = () => {
  const { isCircleV4PreviewEnabled } = useCircleV4();
  const {
    get: shouldShowAdminPreviewModal,
    remove: disableShowingAdminPreviewModalOnNextRender,
  } = useSessionStorage(PREVIEW_MODAL_KEY);
  const modal = useAdminPreviewModal();

  useEffect(() => {
    if (!isCircleV4PreviewEnabled) return;

    if (shouldShowAdminPreviewModal({ onErrorValue: true })) {
      disableShowingAdminPreviewModalOnNextRender();
      void modal.show();
    }
  }, [
    modal,
    shouldShowAdminPreviewModal,
    isCircleV4PreviewEnabled,
    disableShowingAdminPreviewModalOnNextRender,
  ]);
};
